import React, { memo } from "react"
import PropTypes from "prop-types"
import CSlider from "./stencil/cslider-wrapper"
import CText from "./stencil/ctext-wrapper"

const PhilosophySlider = ({
  children,
  lang = "de",
  dimensions,
  activeSlideIndex,
  radioButtonIdOffset,
}) => {
  const content = require("../data/about.json").philosophy[lang]

  return (
    <CSlider
      sliderClasses="about-content"
      loadLastSlideItemHalfway={true}
      slides={2}
      collapseOnMobile={true}
      lang={lang}
      path="about"
      radioButtonIdOffset={radioButtonIdOffset}
      activeSlideIndex={activeSlideIndex}
    >
      <div className="carousel-item">
        <c-image
          account="schneckenhof"
          alias="senses-integration/about/soft-edge-10_pyramid-table_moroccan-vase_1390x800_mk0gu0"
          crop="fill"
          width={dimensions[0]}
          height={
            dimensions[0] < 641
              ? Math.round(dimensions[1] * 0.5)
              : dimensions[1]
          }
        />
      </div>
      <div className="carousel-item">
        {children}
        <CText
          richText={content}
          maxDesktopText={700}
          maxMobileText={lang === "cn" ? 150 : 250}
          noArrows={dimensions[0] < 641 ? true : false}
          viewport={dimensions[0] < 641 ? "mobile" : "desktop"}
          lang={lang}
          radioButtonIdOffset={11}
        />
      </div>
    </CSlider>
  )
}

PhilosophySlider.propTypes = {
  children: PropTypes.node,
  lang: PropTypes.string,
  dimensions: PropTypes.array,
  radioButtonIdOffset: PropTypes.number,
  activeSlideIndex: PropTypes.number,
}

export default memo(PhilosophySlider)
